/**
 * Trims all trailing `/` from a URL
 * @param url
 */
export function trimTrailingSlashes(url: string) {
  return (url ?? '').replace(/\/+$/, '');
}

/**
 * Trims first leading `/` from a path
 * @param path
 */
export function trimLeadingSlash(path: string) {
  return (path ?? '').replace(/^\/?/, '');
}
